import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import style from './section.module.scss';

interface Props {
  header?: ReactNode;
  className?: string;
  headerActions?: ReactNode;
  children?: ReactNode;
}

const Section: FC<Props> = ({ header, children, className, headerActions }) => {
  return (
    <section className={classNames(style.section, className)}>
      {(header || headerActions) && (
        <header>
          <div className={style.content}>
            {header && <h3 className={style.sectionHeading}>{header}</h3>}
            {headerActions && (
              <div className={style.actions}>{headerActions}</div>
            )}
          </div>
        </header>
      )}
      {children}
    </section>
  );
};

export { Section };
